<template>
  <!-- 左边的表 -->

  <div style="padding:10px 6px 10px 10px">
    <a-row style="margin-bottom:10px" type="flex" justify="space-between">
      <a-space>
        <a-button type="primary" @click="toggleVisible('formula')">添加</a-button>
        <a-button :disabled="!selectedRowKeys.length > 0" type="danger" ghost @click="deleteItem">移出</a-button>
        <a-button type="primary" @click="showImportConfirm">一键导入</a-button>
        <template v-if="selectedRowKeys.length > 0">
          <a-tag> 已选择 {{ selectedRowKeys.length }} 项目 </a-tag>
        </template>
      </a-space>
      <a-space>
<!--        <a-button :loading="taskAsyncLoading" :disabled="!selectedRowKeys.length > 0" type="primary"-->
<!--          @click="asyncTask">同步最新配方</a-button>-->
        <a-dropdown :disabled="!selectedRowKeys.length > 0">
          <a-button type="primary" ghost style="width:100px">同步最新数据</a-button>
          <a-menu slot="overlay" @click="({ key }) => callFuntionByKey(key)">
            <a-menu-item v-for="(item, index) in ['同步最新配方', '同步预计生产量表']" :key="index">{{
                item }}</a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown :disabled="!selectedRowKeys.length > 0">
          <a-button type="primary" ghost style="width:80px">批量操作</a-button>
          <a-menu slot="overlay" @click="({ key }) => toggleVisible(modal[key])">
            <a-menu-item v-for="(item, index) in ['批量添加原料', '批量删除原料', '批量修改原料', '批量替换原料', '批量修改营养指标']" :key="index">{{
              item }}</a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-select class="select" v-model="formulaSolutionType" placeholder="配方筛选">
          <a-select-option :key="index" :value="index - 1" v-for="(item, index) in ['所有配方', '不可行配方', '可行配方']">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-space>
    </a-row>
    <a-config-provider>
      <template #renderEmpty>
        <div>
          <span slot="description">还没有添加配方 </span><br />
          <a-button type="primary" @click="toggleVisibleFormula">添加配方</a-button>
        </div>
      </template>
      <resize-table tableName="forumlaColumns" :columns="forumlaColumns" bordered :scroll="{ x: 500, y: height }"
        :loading="feedLoading" :data-source="list.records"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }" :row-key="record => record.id"
        :pagination="false" :rowClassName="rowClassname" @change="getList">
        <span slot="customTitle"><a-icon @click="fixedCol" type="pushpin"
            :theme="filled ? 'filled' : 'outlined'" />配方名称</span>
        <a-tooltip size="small" slot="formulaName" slot-scope="text,item">
          <template slot="title">点击查看配方中原料和营养指标设置</template>
          <a @click="toggleDetail(item)">{{ text }}</a>
        </a-tooltip>
        <template slot="synchronizeTime" slot-scope="text">
          <span :class="colorRecord(text)">{{ text }}</span>
        </template>
        <cell-editor slot="estimateOutput" slot-scope="text, record" :len="3" :item="record" name="estimateOutput"
          @blur="target => itemUpdate(target, record.id)" :text="text" :actions="update" />
        <span v-for="slot in ['taskPrice', 'formulaPrice', 'productPrice']" slot-scope="text" :slot="slot" :key="slot">
          {{ text | numberFixed(3) }}
        </span>
        <template slot-scope="text" slot="productDiffPrice">
          <span v-if="text > 0" style="color:red">↑{{ text | numberFixed(3) }}</span>
          <span v-else-if="text < 0" style="color:green">↓{{ text | numberFixed(3) }}</span>
        </template>
      </resize-table>
    </a-config-provider>
    <add-formula-modal @ok="regetList" @refresh="refreshList" />
    <raw-modal @ok="setState({ resRaw: resRaw + 1 })" />
    <delete-raw-modal @ok="setState({ resRaw: resRaw + 1 })" />
    <modify-raw-modal @ok="setState({ resRaw: resRaw + 1 })" />
    <modify-nutrition-modal @ok="setState({ resNut: resNut + 1 })" @refresh="refreshList" />
    <modify-replace-raw-modal @ok="setState({ resRaw: resRaw + 1 })" />
    <!-- <progress-modal /> -->
  </div>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue';
import AddFormulaModal from '../modal/AddFormulaModal.vue';
import ModifyRawModal from '../modal/ModifyRawModal.vue';
import DeleteRawModal from '../modal/DeleteRawModal.vue';
import ModifyReplaceRawModal from '../modal/ModifyReplaceRawModal.vue';
import ModifyNutritionModal from '../modal/ModifyNutritionModal.vue';
import RawModal from '../modal/RawModal.vue';
import { formulaMixins } from '../unitls';
// import ProgressModal from '../modal/ProgressModal.vue';

export default {
  components: { AddFormulaModal, CellEditor, RawModal, ModifyRawModal, ModifyNutritionModal, DeleteRawModal, ModifyReplaceRawModal },
  mixins: [formulaMixins],
  emits: ['estimatedOutputUpdated'],
  data() {
    return {
      modal: ['batchAddRaw', 'batchDeleteRaw', 'batchModifyRaw', 'batchReplaceRaw', 'batchNutrition'],
      formulaSolutionType: -1,
      list: {},
      feedLoading: false,
      cacheList: undefined,
      taskAsyncLoading: false,
      filled: true,
      pollingIndex: 0,
      importConfirmVisible: false,
    };
  },
  mounted() {
    this.getList({ pageSize: 100, current: 1 });
  },
  watch: {
    '$route'() {
      this.getList(this.pagination);
    },
    formulaSolutionType(type) {
      window.localStorage.setItem('formulaSolutionType', type);
      let list = JSON.parse(JSON.stringify(this.cacheList));
      if (type == -1) {
        this.list.records = list;
      } else {
        this.list.records = list.filter(i => i.formulaSolutionType == type);
      }
    },
    resRaw(val) {
      if (val) this.getList(this.pagination);
    },
  },
  methods: {
    callFuntionByKey(key){
      if (key === 0) {
        this.asyncTask();
      } else if (key === 1) {
        this.asyncEstimated();
      }
    },
    colorRecord(val) {
      let colorStr = '';
      let time = 48 * 60 * 60 * 1000;
      if (val) {
        let current = new Date().getTime();
        let rowTime = new Date(val).getTime();
        if (current - rowTime < time) {
          colorStr = 'green';
        } else {
          colorStr = 'red';
        }
      }
      return colorStr;
    },
    getFilterList() {
      let formulaSolutionType = window.localStorage.getItem('formulaSolutionType');
      if (formulaSolutionType) this.formulaSolutionType = Number(formulaSolutionType);
    },
    changeColumns() {
      let forumlaColumns = [...this.forumlaColumns];
      if (this.filled) {
        forumlaColumns[0].fixed = 'left';
      } else {
        delete forumlaColumns[0].fixed;
      }
      this.setState({ forumlaColumns });
    },
    fixedCol(e) {
      this.filled = !this.filled;
      this.changeColumns();
      e = e || window.event;
      if (e.stopPropagation) { //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    asyncTask() {
      this.$confirm({
        title: '同步最新数据',
        content: '将单配方中的配方和预计生产量表中的数据同步更新至多配方中，你还要继续吗？',
        cancelText: '取消',
        okText: '确定',
        onOk: () => {
          this.pollingIndex = 0;
          this.asyncFormula();
        },
        onCancel() {
        },
      });
    },
    asyncEstimated() {
      this.$confirm({
        title: '同步最新数据',
        content: '将预计生产量表中的数据同步更新至多配方中，你还要继续吗？',
        cancelText: '取消',
        okText: '确定',
        onOk: () => {
          this.pollingIndex = 0;
          this.asyncEstimatedProduction();
        },
        onCancel() {
        },
      });
    },
    async pollingRefresh() {
      await this.fetchPost({
        actions: this.sycFormulaToTask,
        data: {
          taskId: this.taskId,
          taskFormulaIds: this.selectedRows[this.pollingIndex].id,
        },
        showMessage: false,
      });
      if (!this.progressVisible) return;
      if (this.pollingIndex >= (this.selectedRows.length - 1)) {
        this.setState({ progressPercent: 100, progressVisible: false });
        this.regetList();
      } else {
        this.pollingIndex++;
        let progressPercent = Number((100 / (this.selectedRows.length || 1) * this.pollingIndex).toFixed(2));
        this.setState({ progressPercent });
        this.pollingRefresh();
      }
    },
    async asyncFormula() {
      this.$emit('showLoading');
      await this.fetchPost({
        actions: this.sycFormulaToTask,
        data: {
          taskId: this.taskId,
          taskFormulaIds: this.selectedRows.map(i => i.id).join(),
        },
        loading: 'taskAsyncLoading'
      });
      setTimeout(() => {
        this.$emit('showLoading');
      }, 0);
      this.regetList();
    },
    async asyncEstimatedProduction() {
      this.$emit('showLoading');
      await this.fetchPost({
        actions: this.syncLatestEstimatedProduction,
        data: {
          taskId: this.taskId,
          taskFormulaIds: this.selectedRows.map(i => i.id).join(),
        },
        loading: 'taskAsyncLoading'
      });
      setTimeout(() => {
        this.$emit('showLoading');
      }, 0);
      this.regetList();
    },
    regetList() {
      this.formulaSolutionType = -1;
      this.setState({
        resRaw: this.resRaw + 1,
        resNut: this.resNut + 1,
      });
      this.getList(this.pagination);
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      this.setState({
        formulaSelectedRows: selectedRows,
        formulaSelectedRowKeys: selectedRowKeys
      });
      // 触发事件并传递选中的配方数据
      this.$emit('selected-recipes', this.selectedRows);
    },

    rowClassname(record) {
      const { formula } = this;
      let className = '';
      if (record.formulaSolutionType == 0) className = 'selectRows';
      if (formula && formula.id && formula.id === record.id) className = 'selectRows-sel';
      return className;
    },

    toggleDetail(formula) {
      if (formula.formulaType == 2) {
        this.toggleVisible('formulaMixDetail');
      } else {
        this.toggleVisible('formulaDetail');
      }
      this.setState({ formula });
    },
    toggleVisibleFormula(){
       this.toggleVisible('formula');
    },
    // 批量添加原料
    toggleBatchAddRaw() {
      this.toggleVisible('batchAddRaw');
    },
// 批量删除原料
    toggleBatchDeleteRaw() {
      this.toggleVisible('batchDeleteRaw');
    },
// 批量修改原料
    toggleBatchModifyRaw() {
      this.toggleVisible('batchModifyRaw');
    },
// 批量替换原料
    toggleBatchReplaceRaw() {
      this.toggleVisible('batchReplaceRaw');
    },
// 批量修改营养指标
    toggleBatchNutrition() {
      this.toggleVisible('batchNutrition');
    },
    showImportConfirm() {
      this.$confirm({
        title: '一键导入',
        content: '确定将预计生产量表中的配方及计划销量导入到任务中吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.handleImport();
        },
        onCancel() {},
      });
    },
    async handleImport() {
      this.$emit('showLoading');
      await this.fetchPost({
        actions: this.oneClickImport,
        data: {
          taskId: this.taskId,
        },
        loading: 'taskAsyncLoading'
      });
      setTimeout(() => {
        this.$emit('showLoading');
      }, 0);
      this.regetList();
    },
    update(data) {
      if (data.estimateOutput === null) data.estimateOutput = 0;
      return this.fetchPost({
        actions: this.updateFormulaTaskFormula,
        data,
        showMessage: false,
      }).then(() => {
        //修改cacheList中的预计产量值
        this.cacheList.forEach(item => {
          if (item.id === data.id) {
            item.estimateOutput = data.estimateOutput;
          }
        });
        this.$emit('estimatedOutputUpdated');
      });
    },

    itemUpdate(item, id) {
      const list = [...this.list.records];
      const targets = list.filter(item => id === item.id)[0];
      if (targets) {
        this.list.records = list;
        Object.assign(targets, item);
        this.list.records = list;
      }
    },

    async getList(arg = {}) {
      let factoryId = window.localStorage.getItem('factoryId');
      let { current = 1 } = arg || this.pagination;
      const res = await this.fetchGet({
        actions: this.selectFormulaTaskFormulaPage,
        name: 'list',
        loading: 'feedLoading',
        isList: true,
        data: {
          taskId: this.taskId,
          factoryId,
          size: 999999,
          current,
        },
      });
      const formulaList = res && res.data && res.data.records ? res.data.records : null;
      this.cacheList = JSON.parse(JSON.stringify(formulaList));
      this.$emit('setList', { field: 'formulaList', list: formulaList });
      this.setState({ formulaList: formulaList });
      this.getFilterList();
      return formulaList;
    },

    async deleteItem() {
      this.$confirm({
        title: '提示',
        content: '配方移出后，该配方中将不再参与评估，你还要继续吗？',
        okText: '继续',
        cancelText: '取消',
        onOk: async () => {
          const ids = this.formulaSelectedRows.map(i => i.id).join();
          const data = { taskId: this.taskId, ids };
          await this.fetchPost({
            actions: this.deleteFormulaTaskFormulaRelLogic,
            data,
          });
          if (this.formulaSelectedRows.some(i => i.id === this.formula.id)) this.setState({ formula: {} });
          this.cleanSelect();
          this.getList(this.pagination);
          this.setState({
            resRaw: this.resRaw + 1,
            resNut: this.resNut + 1,
          });
          this.$emit('refresh');
          this.$emit('selected-recipes', this.selectedRows);
        },
        onCancel() { },
      });
    },
    refreshList() {
      this.$emit('refresh');
    }
  }
};
</script>
<style scoped lang="scss">
.select {
  width: 150px
}

::v-deep .selectRows {
  background-color: rgba(255, 206, 163, 0.1) !important;
  background-color: #fff9e5 !important;
}

.selectGary {
  background-color: rgba(130, 130, 130, 0.1) !important;
}

::v-deep .selectRows-sel {
  background-color: rgba(86, 204, 242, 0.2);
}

.disabled {
  color: #888;
}

.list-item {
  font-size: 12px;
}

.dropdown-list {
  max-height: 300px;
  width: 240px;
  overflow: auto;
  margin: -10px;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss">
.red {
  color: red;
}

.green {
  color: green
}
</style>
